import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '最新动态', href: '#updates' },
  { label: '专题聚焦', href: '#carousel' },
  { label: '热门话题', href: '#topics' },
  { label: '平台优势', href: '#features' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-[72px] px-4 md:px-8 max-w-[1440px] mx-auto">
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, '#hero')}
          className="flex items-center gap-2 cursor-pointer no-underline"
        >
          <span className="text-xl md:text-2xl font-heading font-bold text-primary-500 whitespace-nowrap">
            90影视
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md hover:bg-primary-50 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#app"
            onClick={(e) => handleNavClick(e, '#app')}
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-line w-4 h-4 flex items-center justify-center"></i>
            APP下载
          </a>
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl w-5 h-5 flex items-center justify-center`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 flex flex-col gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#app"
            onClick={(e) => handleNavClick(e, '#app')}
            className="mt-2 px-4 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-md text-center hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-line mr-1.5 w-4 h-4 inline-flex items-center justify-center"></i>
            APP下载
          </a>
        </nav>
      )}
    </header>
  );
}